import axios from 'axios';
import {req, getByobj, exportExcel, postobj} from './axiosFun';

/**
 * 商品管理
 **/
// 商品管理-获取商品管理列表
export const GoodsList = (params) => { return getByobj("get", "/product/listByPage", params) };
// 商品管理-推荐商品
export const GoodsRecommend = (params) => { return req("post", "/product/recommend", params) };

// 商品管理-保存商品
export const GoodsSave = (params) => { return postobj("post", "/product/insert", params) };
// 商品管理-修改商品
export const GoodsEdit = (params) => { return postobj("post", "/product/update", params) };
// 商品管理-删除商品
export const GoodsDelete = (id) => { return req("post","/product/deleteById?id="+id) };
// 商品管理-根据id查看详情
export const GoodsFindById = (id) => { return req("post","/product/findById/"+id) };
// 商品管理-设置为首页推荐
export const setRecommend = (params) => { return getByobj("post","/product/recommend",params) };
// 已推荐列表
export const recommendList = (params) => { return getByobj("get","/recommend/listByPage",params) };
// 已推荐删除
export const delRecommend = (params) => { return req("post","/recommend/deleteById",params) };
// 产品分类list
export const classiFicationList = (params) => { return getByobj("get","/classification/listByPage",params) };
// 产品分类add
export const addClassiFication = (params) => { return req("post","/classification/insert",params) };
// 产品分类del
export const delClassiFication = (params) => { return req("post","/classification/deleteById?id="+params) };
// 产品分类编辑
export const editClassiFication = (params) => { return req("post","/classification/update",params) };
// 产品分类通过id查询
export const getClassiFicationById = (params) => { return req("get","/classification/findById/"+params) };
// 产品分类下拉列表
export const getClassiFicationTypeList = () => { return req("get","/classification/list") };
//产品品牌列表
export const brandList = (params) => { return getByobj("get","/brand/listByPage",params) };
//产品品牌新增
export const addBrand = (params) => { return postobj("post","/brand/insert",params) };
//产品品牌修改
export const updateBrand = (params) => { return postobj("post","/brand/update",params) };
//产品品牌删除
export const delBrand = (params) => { return req("post","/brand/deleteById?id="+params) };
//产品品牌状态修改
export const updateState = (params) => { return req("post",`/brand/updateState?id=${params.id}&state=${params.state}`,params) };

// 产品上、下架
export const underCarriage = (params) => { return getByobj("post","/product/underCarriage",params) };
// 导出产品
export const exportProduct = (params) => { return exportExcel("post","/product/export",params) };
// 获取国家国旗信息
export const getNationalList = (params) => { return getByobj("get","/national/listByPage",params) };
// 添加国家国旗信息
export const addNational = (params) => { return req("post","/national/insert",params) };
// 修改国家国旗信息
export const editNational = (params) => { return req("post","/national/update",params) };
// 根据id删除国家国旗信息
export const delNational = (params) => { return req("post","/national/deleteById?id="+params) };
// 根据id查询国家国旗信息
export const findNational = (id) => { return req("get","/national/findById/"+id) };
//  国家下拉列表
export const getRoleList = () => { return req("get","/national/getRoleList") };

//  协议列表
export const getUserAgreeList = (params) => { return req("get","/userAgree/list",params) };
//  协议编辑
export const updateUserAgreeList = (params) => { return req("post","/userAgree/update",params) };
//  协议新增
export const addUserAgreeList = (params) => { return req("post","/userAgree/insert",params) };
//  协议删除
export const delUserAgreeList = (params) => { return req("post","/userAgree/delete?id="+params) };


// 同步到积分商城
export const synToIntegral = (params) => { return req("post","/product/synToIntegral?id="+params) };
//  积分商品 /app/vip/vipProduct/listByPage  /vipProduct/listByPage
export const vipProductList = (params) => { return getByobj("get","/app/vip/vipProduct/listByPage",params) };
//  积分商品删除
export const delVipProduct = (params) => { return req("post","/app/vip/vipProduct/deleteById?ids="+params) };
//  积分商品修改积分金额 /app/vip/vipProduct/update  /vipProduct/update
export const updateVipProduct = (params) => { return req("post","/app/vip/vipProduct/update",params) };

//  积分流水 /app/vip/vipIntegralFlow/getAllFalow /vipIntegralFlow/getAllFalow
export const getAllFalow = (params) => { return getByobj("get","/app/vip/vipIntegralFlow/getAllFalow",params) };

// 搜索热词配置
//  搜索热词列表
export const getHotSearchList = (params) => { return req("get","/hotSearch/getHotSearch",params) };
//  搜索热词编辑
export const updateHotSearch = (params) => { return req("post","/hotSearch/update",params) };
//  搜索热词新增
export const addHotSearch = (params) => { return req("post","/hotSearch/insert",params) };
//  搜索热词删除
export const delHotSearch = (params) => { return req("post","/hotSearch/deleteById?id="+params) };



// WEBPACK FOOTER //
// ./src/api/basisMG.js